import { render, staticRenderFns } from "./CertificateTypeList.vue?vue&type=template&id=dc4b919c&scoped=true&"
import script from "./CertificateTypeList.vue?vue&type=script&lang=js&"
export * from "./CertificateTypeList.vue?vue&type=script&lang=js&"
import style0 from "./CertificateTypeList.vue?vue&type=style&index=0&id=dc4b919c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b919c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex})
